import React, { PureComponent } from "react";

import {
  CustomizedXAxisTickTimeDay,
  CustomizedYAxisTick,
  CustomizedYAxisTickRight,
  Error,
  selectFormat,
  StandardTooltip,
  Metric,
  formatDateFromData,
  isDateFromDataInISOFormat,
} from "./../Utils/Utils.js";

import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import Heading from "./../Elements/Heading";

class DonationsLineChart extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  legendElement = (data) =>
    data.map((entry, i) => (
      <span
        key={i}
        className="legend mt-2 mt-md-0"
        style={{ opacity: entry.opacity || 1 }}
      >
        <span
          className={
            "legend__icon " +
            (entry.type === "line" ? "legend__icon--line" : "")
          }
          style={{
            background: entry.type === "line" ? "unset" : entry.color,
            borderTop:
              entry.type === "line" ? "1px dashed " + entry.color : "unset",
          }}
        ></span>
        <span className="legend__text" style={{ color: entry.color }}>
          {entry.key}
        </span>
      </span>
    ));

  renderLegends = (data) => {
    const legends = [
      { key: "New Donations", color: "#fc6d52", type: "rect" },
      { key: "Emails", color: "#f89481", opacity: 0.6, type: "rect" },
    ];

    return this.legendElement(legends);
  };

  getExportData = () => ({
    data: this.props.data.graph
      .filter((d) => d.new_transactions || d.visits)
      .map((d) => {
        d["new_transactions_label"] = "New Donations";
        d["visits_label"] = "Emails";
        return d;
      }),
    opts: {
      type: "chart",
      values: ["new_transactions", "visits"],
      date: {
        // overwrites the default settings for date only when the date is in ISO format
        defined: isDateFromDataInISOFormat(this.props.data.graph),
        format: "YYYY-MM-DDThh:mm:ssZ",
        viewFormat: "YYYY-MM-DD",
      },
    },
  });

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let preparedData = formatDateFromData(this.props.data.graph, "YYYY/MM/DD");
    // TODO
    if (preparedData && !preparedData[0].average) {
      preparedData.forEach((d) => (d.average = d.yesterday));
    }

    return (
      <>
        <div className="row mb-2">
          <div className="col-6 col-md-6">
            <Heading size={6} className={"mb-1"}>
              Emails
            </Heading>
            <div className="d-inline-block">
              <Metric {...data.visits} size={"md"} />
            </div>
          </div>

          <div className="col-6 col-md-6">
            <Heading size={6} className={"mb-1"}>
              New Donations
            </Heading>
            <div className="d-inline-block">
              <Metric {...data.new_donations} size={"md"} />
            </div>
          </div>
        </div>

        {this.renderLegends(preparedData)}

        <ResponsiveContainer height={300} width="100%">
          <ComposedChart
            data={preparedData}
            margin={{ top: 12, right: 0, bottom: 0, left: 0 }}
          >
            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={
                <StandardTooltip
                  render={({ data }) => {
                    const payload = data(this.props);

                    if (payload !== null) {
                      const tooltip_data = payload[0].payload;

                      return (
                        <div className="standard-tooltip">
                          {tooltip_data && tooltip_data.date && (
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Date:
                              </span>
                              <span className="standard-tooltip__value-header">
                                {tooltip_data.date}
                              </span>
                            </header>
                          )}
                          <main className="standard-tooltip__main">
                            {tooltip_data && tooltip_data.visits && (
                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key">
                                  {payload[1] && (
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{
                                        background: payload[0].fill,
                                        opacity: 0.2,
                                      }}
                                    ></span>
                                  )}
                                  Emails
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat("number", tooltip_data.visits)}
                                </span>
                              </div>
                            )}

                            {tooltip_data && tooltip_data.new_transactions && (
                              <div className="standard-tooltip__item">
                                <span className="standard-tooltip__key">
                                  {payload[0] && (
                                    <span
                                      className="standard-tooltip__icon"
                                      style={
                                        payload[1] === undefined
                                          ? { background: payload[0].stroke }
                                          : { background: payload[1].stroke }
                                      }
                                    ></span>
                                  )}
                                  New Donations
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat(
                                    "number",
                                    tooltip_data.new_transactions
                                  )}
                                </span>
                              </div>
                            )}
                          </main>
                        </div>
                      );
                    }
                  }}
                />
              }
            />

            <CartesianGrid
              stroke="#FEE5DE"
              strokeDasharray="3 3"
              vertical={false}
            />
            <Area
              type="monotone"
              connectNulls
              dataKey="visits"
              fillOpacity={0.2}
              fill="#f89481"
              stroke="none"
              yAxisId="left"
            />
            <Line
              type="monotone"
              connectNulls
              dataKey="new_transactions"
              fill="#fc6d52"
              stroke="#fc6d52"
              strokeWidth="3"
              dot={false}
              yAxisId="right"
            />

            <XAxis
              dataKey="date"
              axisLine={false}
              tickLine={false}
              tick={<CustomizedXAxisTickTimeDay />}
            />

            <YAxis
              yAxisId="left"
              axisLine={false}
              tickLine={false}
              tick={<CustomizedYAxisTick />}
              width={20}
            />
            <YAxis
              yAxisId="right"
              axisLine={false}
              tickLine={false}
              orientation="right"
              tick={<CustomizedYAxisTickRight />}
              width={20}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </>
    );
  }
}

export default DonationsLineChart;
